import React from "react";
import {
  AHIcon,
  AHIconType,
  AHText,
  Box,
  Circle,
  ColorType,
  Space,
  useLayoutContext,
} from "arkh";
import { Pressable, PressableProps, ViewStyle } from "react-native";

export function TeamHeaderButton(
  props: {
    onPress: () => void;
    onPressIn?: () => void;
    icon?: AHIconType;
    title?: React.ReactNode;
    tintColor?: ColorType;
    containerStyle?: ViewStyle;
    itemStyle?: ViewStyle;
    spaceLeft?: Space;
    spaceRight?: Space;
  } & Pick<PressableProps, "hitSlop" | "pressRetentionOffset">
) {
  const tintColor = props.tintColor ?? "primary";
  const layout = useLayoutContext();
  return (
    <Pressable
      onPressIn={props.onPressIn}
      hitSlop={props.hitSlop}
      pressRetentionOffset={props.pressRetentionOffset}
      onPress={props.onPress}
      style={[
        {
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: layout.space[props.spaceLeft ?? "none"],
          paddingRight: layout.space[props.spaceRight ?? "none"],
        },
        props.containerStyle,
      ]}
    >
      {({ pressed }) => (
        <Box
          style={[
            {
              height: layout.circle.medium,
              width: !props.title ? layout.circle.medium : undefined,
              flexDirection: "row",
              justifyContent: "center",
              borderRadius: layout.circle.medium,
              alignItems: "center",
              opacity: pressed ? 0.3 : 1,
            },
            props.itemStyle,
          ]}
        >
          {props.icon ? (
            <Circle size="medium">
              <AHIcon type={props.icon} size="large" color={tintColor} />
            </Circle>
          ) : null}
          {props.title ? (
            <AHText
              type="subtitle"
              spaceLeft="xsmall"
              spaceRight="xsmall"
              selectable={false}
              color={tintColor}
            >
              {props.title}
            </AHText>
          ) : null}
        </Box>
      )}
    </Pressable>
  );
}
